const initialData_in = [
    {name: "paraCd", type: "hidden", value: "", readOnly: true,cmptCheck:false, cmptType:""},
    {name: "paraNm", type: "select", value: "", options: "main",cmptCheck:false, cmptType:""},
    {name: "paraDesc", type: "text", value: "",cmptCheck:false, cmptType:""},
    {name: "unit", type: "select", value: "", options: "unit",cmptCheck:false, cmptType:"",style: { textAlign: "center" }},
    {name: "rcvCriticalNm", type: "select", value: "", options: "critical",style: { textAlign: "center" },cmptCheck:false, cmptType:""},
    {name: "rcvSetpoint", type: "text", value: "",cmptCheck:false, cmptType:""},
    {name: "rcvTarMinSign", type: "select", value: "", options: "sign",cmptCheck:false, cmptType:""},
    {name: "rcvTarMin", type: "text", value: "",cmptCheck:false, cmptType:""},
    {name: "rcvTarMaxSign", type: "select", value: "", options: "sign",cmptCheck:false, cmptType:""},
    {name: "rcvTarMax", type: "text", value: "",cmptCheck:false, cmptType:""},
    {name: "rcvAccMinSign", type: "select", value: "", options: "sign",cmptCheck:false, cmptType:""},
    {name: "rcvAccMin", type: "text", value: "",cmptCheck:false, cmptType:""},
    {name: "rcvAccMaxSign", type: "select", value: "", options: "sign",cmptCheck:false, cmptType:""},
    {name: "rcvAccMax", type: "text", value: "",cmptCheck:false, cmptType:""},
    {name: "sndCritical", type: "text", value: "",style: { textAlign: "center" },cmptCheck:false, cmptType:""},
    {name: "sndSetpoint", type: "text", value: "",cmptCheck:false, cmptType:""},
    {name: "sndTarMinSign", type: "select", value: "", options: "sign",cmptCheck:false, cmptType:""},
    {name: "sndTarMin", type: "text", value: "",cmptCheck:false, cmptType:""},
    {name: "sndTarMaxSign", type: "select", value: "", options: "sign",cmptCheck:false, cmptType:""},
    {name: "sndTarMax", type: "text", value: "",cmptCheck:false, cmptType:""},
    {name: "sndAcc1MinSign", type: "select", value: "", options: "sign",cmptCheck:false, cmptType:""},
    {name: "sndAcc1Min", type: "text", value: "",cmptCheck:false, cmptType:""},
    {name: "sndAcc1MaxSign", type: "select", value: "", options: "sign",cmptCheck:false, cmptType:""},
    {name: "sndAcc1Max", type: "text", value: "",cmptCheck:false, cmptType:""},
    {name: "reference", type: "text", value: "",cmptCheck:false, cmptType:""},
    {name: "remark", type: "checkbox", value: "FALSE",cmptCheck:false, cmptType:""},
    {name: "hide", type: "checkbox", value: "FALSE",cmptCheck:false, cmptType:""},
    {name: "uniqueCode", type: "hidden", value : "", type2: "hidden"}
];

const initialData_out = [
    {name: "paraCd", type: "hidden", value: "", readOnly: true},
    {name: "testItem", type: "select", value: "", options: "main"},
    {name: "samplePointNm", type: "hidden", value: "", options: "sample", label: ""},
    {name: "dayCycle", type: "hidden", value: ""},
    {name: "paraNm", type: "text", value: ""},
    {name: "sopNo", type: "text", style: { textAlign: "center" },value: ""},
    {name: "unit", type: "select", value: "", style: { textAlign: "center" },options: "unit"},
    {name: "rcvCritical", type: "hidden", value: "", type2: "hidden"},
    {name: "rcvCriticalNm", type: "select", value: "",style: { textAlign: "center" }, options: "critical"},
    {name: "rcvSetpoint", type: "text", value: ""},
    {name: "rcvTarMinSign", type: "select", value: "", options: "sign"},
    {name: "rcvTarMin", type: "text", value: ""},
    {name: "rcvTarMaxSign", type: "select", value: "", options: "sign"},
    {name: "rcvTarMax", type: "text", value: ""},
    {name: "rcvAccMinSign", type: "select", value: "", options: "sign"},
    {name: "rcvAccMin", type: "text", value: ""},
    {name: "rcvAccMaxSign", type: "select", value: "", options: "sign"},
    {name: "rcvAccMax", type: "text", value: ""},
    {name: "sndCritical", type: "text", style: { textAlign: "center" },value: ""},
    {name: "sndSetpoint", type: "text", value: "" },
    {name: "sndTarMinSign", type: "select", value: "", options: "sign"},
    {name: "sndTarMin", type: "text", value: ""},
    {name: "sndTarMaxSign", type: "select", value: "", options: "sign"},
    {name: "sndTarMax", type: "text", value: ""},
    {name: "sndAcc1MinSign", type: "select", value: "", options: "sign"},
    {name: "sndAcc1Min", type: "text", value: ""},
    {name: "sndAcc1MaxSign", type: "select", value: "", options: "sign"},
    {name: "sndAcc1Max", type: "text", value: ""},
    {name: "reference", type: "text", value: ""},
    {name: "remark", type: "checkbox", value: "FALSE"},
    {name: "hide", type: "checkbox", value: "FALSE"},
    {name: "uniqueCode", type: "hidden", value : "", type2: "hidden"}
];

const initialData_qc = [
    { name: "paraCd", type: "hidden", value: "QC", required: true, type2: "hidden" },
    {
        name: "samplePoint",
        type: "hidden",
        value: "",
        options: "sample",
        label: "",
        required: true,
        type2: "hidden",
    },
    { name: "dayCycle", type: "hidden", value: "", required: true, maxLength: "2", type2: "hidden" },
    { name: "sampleDesc", type: "select", value: "", options: "qcGroup", required: true },
    { name: "paraNm", type: "text", value: "", required: true },
    { name: "testMethod", type: "text", value: "", style: { textAlign: "center" },required: true },
    { name: "unit", type: "text", value: "", style: { textAlign: "center" }, required: true },
    {name: "rcvCritical", type: "hidden", value: "", type2: "hidden"},
    {name: "rcvCriticalNm", type: "select", value: "", style: { textAlign: "center" },options: "critical"},
    {
        name: "rcvAlrMinSign",
        type: "select",
        value: "",
        options: "sign",
        opttype: "max",
        style: { textAlign: "center" },
    },
    { name: "rcvAlrMin", type: "text", value: "", style: { textAlign: "right" } },
    {
        name: "rcvAlrMaxSign",
        type: "select",
        value: "",
        options: "sign",
        opttype: "min",
        style: { textAlign: "center" },
    },
    { name: "rcvAlrMax", type: "text", value: "", style: { textAlign: "right" } },
    {
        name: "rcvActMinSign",
        type: "select",
        value: "",
        options: "sign",
        opttype: "max",
        style: { textAlign: "center" },
    },
    { name: "rcvActMin", type: "text", value: "", style: { textAlign: "right" } },
    {
        name: "rcvActMaxSign",
        type: "select",
        value: "",
        options: "sign",
        opttype: "min",
        style: { textAlign: "center" },
    },
    { name: "rcvActMax", type: "text", value: "", style: { textAlign: "right" } },
    {
        name: "rcvAccMinSign",
        type: "select",
        value: "",
        options: "sign",
        opttype: "min",
        style: { textAlign: "center" },
    },
    { name: "rcvAccMin", type: "text", value: "" },
    {
        name: "rcvAccMaxSign",
        type: "select",
        value: "",
        options: "sign",
        opttype: "max",
        style: { textAlign: "center" },
    },
    { name: "rcvAccMax", type: "text", value: "" },
    // { name: "rcvCopy", type: "button", value: "", type2: "hidden" },
    { name: "sndCritical", type: "text",style: { textAlign: "center" }, value: "" },
    {
        name: "sndAlrMinSign",
        type: "select",
        value: "",
        options: "sign",
        opttype: "all",
        style: { textAlign: "center" },
    },
    { name: "sndAlrMin", type: "text", value: "", style: { textAlign: "right" } },
    {
        name: "sndAlrMaxSign",
        type: "select",
        value: "",
        options: "sign",
        opttype: "all",
        style: { textAlign: "center" },
    },
    { name: "sndAlrMax", type: "text", value: "", style: { textAlign: "right" } },
    {
        name: "sndAct1MinSign",
        type: "select",
        value: "",
        options: "sign",
        opttype: "all",
        style: { textAlign: "center" },
    },
    { name: "sndAct1Min", type: "text", value: "", style: { textAlign: "right" } },
    {
        name: "sndAct1MaxSign",
        type: "select",
        value: "",
        options: "sign",
        opttype: "all",
        style: { textAlign: "center" },
    },
    { name: "sndAct1Max", type: "text", value: "", style: { textAlign: "right" } },
    {
        name: "sndAccMinSign",
        type: "select",
        value: "",
        options: "sign",
        opttype: "all",
        style: { textAlign: "center" },
    },
    { name: "sndAccMin", type: "text", value: "" },
    {
        name: "sndAccMaxSign",
        type: "select",
        value: "",
        options: "sign",
        opttype: "all",
        style: { textAlign: "center" },
    },
    { name: "sndAccMax", type: "text", value: "" },
    { name: "optionCd", type: "select", value: "", options: "qcoption" },
    { name: "reference", type: "text", value: "" },
    { name: "remark", type: "checkbox", value: "FALSE" },
    { name: "hide", type: "hidden", value: "FALSE", maxLength: 1500, type2: "hidden" },
    { name: "uniqueCode", type: "hidden", type2: "hidden" },
    { name: "soSeq", type: "hidden", type2: "hidden" },
    { name: "paraSeq", type: "hidden", type2: "hidden" },
];

const initialData_comp = [
    {name: "paraCd", type: "hidden", value: ""},
    {name: "materialCd", type: "text", value: ""},
    {name: "component", type: "text", value: ""},
    {name: "mainAlter", type: "select", value: "", options: "mainalter"},
	{name: "concentration", type: "text", value: ""},
    {name: "unit1", type: "text", value: "", style:{textAlign: "right"}, borderStyle:{textAlign: "right", borderRight: "none"},revCelNm :"unit1+unit2"},
    {name: "unitseperator", type: "seperator", value: "/", borderStyle:{borderLeft: "none", borderRight: "none", padding: 0, textAlign: "center"}},
    {name: "unit2", type: "text", value: "", borderStyle:{borderLeft: "none"},revCelNm :"unit1+unit2"},
    {name: "reference", type: "text", value: ""},
    {name: "remark", type: "checkbox", value: "FALSE"},
    {name: "uniqueCode", type: "hidden",  value : "",type2: "hidden"}
];

export { initialData_in, initialData_out, initialData_qc, initialData_comp }